module.exports = "/assets/packs/images/7dbdc68d0970ada09b7f9fe96eada0b1.png";